<template>
  <v-content>
    <v-container>
      <v-card max-width="85%" class="mx-auto">
        <v-card-title>
          <h3 class="mx-auto">
            Map Pincodes
          </h3>
        </v-card-title>
        <v-card-text>
          <v-alert transition="scroll-y-transition" prominent type="error" :value="error.status">
            {{error.message}}
          </v-alert>
          <v-alert transition="scroll-y-transition" prominent type="success" :value="success.status">
            {{success.message}}
          </v-alert>
          <v-form class="text-center" ref="mapPincodeForm" @submit.prevent="mapPincode">
            <v-autocomplete
              v-model="pincode"
              label="Pincodes"
              color="accent"
              :items="pincodesToMap"
              :item-text="pincodeSelectText"
              item-value="pincode"
              :rules="pincodeRules"
            ></v-autocomplete>
            <v-autocomplete
              label="Select ASO"
              v-model="selectedAso"
              :items="asos"
              item-text="name"
              :rules="asoRules"
              :return-object="true"
            ></v-autocomplete>
            <v-btn type="submit" :loading="processing" color="accent">Map Pincode</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      asos: [],
      pincodesToMap: [],
      pincode: null,
      selectedAso: null,
      processing: false,
      success: {
        status: false,
        message: '',
      },
      error: {
        status: false,
        message: '',
      },
    };
  },
  methods: {
    async mapPincode() {
      // here we must map pincode
      this.success.status = false;
      this.error.status = false;
      if (this.$refs.mapPincodeForm.validate()) {
        // this.processing = true;
        // console.log(this.pincode);
        const { selectedAso } = this;
        try {
          const orders = await this.firebase.firestore().collection('aso-order').where('zipcode', '==', this.pincode).get();
          orders.forEach(async (order) => {
            const fullOrder = await this.firebase.firebase().collection('orders').doc(order.id).get();
            // console.log(fullOrder);
            await fullOrder.ref.udpate({
              aso: true,
              asoId: selectedAso.id,
              asoCustomerCode: selectedAso.otcCode,
            });
            const ordersData = await order.data();
            await order.ref.update({
              aso: true,
              asoId: selectedAso.id,
              asoName: selectedAso.name,
              asoEmail: selectedAso.email,
            });
            // here we should also send email for the id
            await fetch('https://19evd2iz3e.execute-api.ap-south-1.amazonaws.com/Prod/order-email-notification-aso', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              mode: 'cors',
              body: JSON.stringify({ aso: selectedAso, orderId: ordersData.id }),
            });
          });
          await this.firebase.firestore().collection('pincodes').doc(`${this.pincode}`).set({
            asoId: selectedAso.id,
            asoName: selectedAso.name,
          });
          await this.firebase.firestore().collection('pincode-to-map').doc(`${this.pincode}`).delete();
          // console.log(orders);
          this.success.status = true;
          this.success.message = 'Pincode mapped successfully';
          this.processing = false;
          this.formReset();
          this.$refs.mapPincodeForm.resetValidation();
          this.pincodesToMap = [];
          this.getPincodeToMap();
        } catch (error) {
          console.log(error);
          this.error.status = true;
          this.error.message = 'Unknown Error! Please try again';
          this.processing = false;
        }
      }
    },
    formReset() {
      this.pincode = null;
      this.selectedAso = null;
    },
    async getPincodeToMap() {
      const { pincodesToMap } = this;
      try {
        const query = await this.firebase.firestore().collection('pincode-to-map').get();
        query.forEach(async (pincode) => {
          pincodesToMap.push({ pincode: pincode.id, city: await pincode.get('city') });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getAsos() {
      // do this
      const { asos } = this;
      try {
        const asosQuery = await this.firebase.firestore().collection('asos').orderBy('name').get();
        asosQuery.forEach(async (item) => {
          asos.push({ uid: item.id, ...await item.data() });
        });
      } catch (error) {
        console.log(error);
      }
    },
    pincodeSelectText(v) {
      return `${v.pincode} - ${v.city}`;
    },
  },
  computed: {
    pincodeRules() {
      return [
        (v) => !!v || 'Pincode is required',
        (v) => (!isNaN(v)) || 'Pincode should be a number',
        (v) => (parseInt(v, 10) > 0) || 'Pincode can not be a negative or 0 value',
        (v) => (v !== null && v.length === 6) || 'Pincode should be 6 numbers',
      ];
    },
    asoRules() {
      return [
        (v) => !!v || 'ASO is required',
      ];
    },
  },
  beforeMount() {
    this.getPincodeToMap();
    this.getAsos();
    // this.testSendMail();
  },
};
</script>
